<template>
  <SettingsPagePanelHeader>
    <template v-slot:title>{{ title }}</template>
    <template v-slot:right>
      <div :class="$style.buttons">
        <template v-if="isEditing">
          <FlatButton variant="secondary" size="medium" @click="handleCancel"
            >キャンセル
          </FlatButton>
          <FlatButton
            variant="primary"
            size="medium"
            @click="emit('buttonClick')"
            :disabled="isButtonDisabled"
          >
            保存
          </FlatButton>
        </template>
        <template v-else>
          <FlatButton
            variant="primary"
            size="medium"
            @click="emit('buttonClick')"
            :disabled="isButtonDisabled"
          >
            <template #icon>
              <IconPen />
            </template>
            編集
          </FlatButton>
        </template>
      </div>
    </template>
  </SettingsPagePanelHeader>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import IconPen from '@/components/icons/IconPen.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'
import SettingsPagePanelHeader from '../SettingsPagePanelHeader.vue'

const props = defineProps<{
  title: string
  isEditing: boolean
  isButtonDisabled: boolean
}>()

const emit = defineEmits<{
  (event: 'buttonClick'): void
  (event: 'cancel'): void
}>()

const title = computed(() =>
  props.isEditing ? `${props.title} - 編集中` : props.title
)

const handleCancel = () => {
  emit('cancel')
}
</script>

<style lang="scss" module>
.buttons {
  display: flex;
  align-items: center;
  gap: 16px;
}
</style>
